export default __webpack_public_path__ + "static/media/eurelectric.8af0c421.jpg";